import {Component, OnInit, Input} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss']
})
export class OrderComponent implements OnInit {

  orderForm: FormGroup;
  isSubmitted: boolean;
  submitError: boolean;
  minHeadsApply: boolean;

  constructor(private fb: FormBuilder,
              private http: HttpClient,
              private spinner: NgxSpinnerService) {
    this.isSubmitted = false;
    this.submitError = false;
    this.minHeadsApply = false;
  }

  // Form Validator
  ngOnInit() {
    this.orderForm = this.fb.group({
      store: ['', Validators.required],
      name: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', Validators.email],
      heads: ['', Validators.required],
      date: ['', Validators.required],
      time: ['', Validators.required],
      remark: ['']
    });
    document.getElementById('heads').addEventListener('input', function (event: any) {
      event.target.value = event.target.value.replace(/\-/g, '');
    });
  }

  onOrderSuccess() {
    if (this.orderForm.valid) {
      this.spinner.show();
      const params = this.orderForm.value;
      if (params.store === '唐人街门店' && params.heads < 5) {
        this.minHeadsApply = true;
        this.spinner.hide();
      } else {
        this.minHeadsApply = false;
        this.submitError = false;
        this.http.post('https://api.mealto.com/restaurant/web/v1/reservation/create',
          {
            'company_id': 7,
            'branch': params.store,
            'contact_name': params.name,
            'contact_phone': params.phone,
            'contact_email': params.email,
            'start_time': params.date.concat(' ').concat(params.time).concat(':00'),
            'heads': params.heads,
            'description': params.remark,
            'deposit': 0
          }
        ).subscribe((res: any) => {
          this.spinner.hide();
          this.isSubmitted = true;
          if (res.code === 200) {
            this.orderForm.reset();
          }
        }, (error) => {
          this.spinner.hide();
          this.submitError = true;
        });

      }
    }
  }

}
